import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { FileTextOutlined } from '@ant-design/icons'
import { SkipNavContent, SkipNavLink } from '@reach/skip-nav'
import { FloatButton } from 'antd/lib'
import { useAutoLogout } from 'hooks/useAutoLogout/useAutoLogout'

import Clipboard from 'components/organisms/Clipboard/Clipboard'
import Navigation from 'components/organisms/Navigation/Navigation'
import TermsAndConditionsModal from 'components/organisms/TermsAndConditionsModal/TermsAndConditionsModal'
import AuthGate from 'components/utilityComponents/AuthGate/AuthGate'

import { InnerWrapper, Wrapper } from './Layout.styles'
import GlobalStyle from 'theme/global.styles'
import '@reach/skip-nav/styles.css'

const Layout: FC = (props) => {
    const { t } = useTranslation()
    useAutoLogout()

    return (
        <Wrapper>
            <GlobalStyle />

            <SkipNavLink>{t('skip_to_main_content')}</SkipNavLink>
            <Navigation />
            <SkipNavContent />

            <main>
                <InnerWrapper>{props.children}</InnerWrapper>
            </main>

            <AuthGate noFallback>
                <TermsAndConditionsModal />
                <Clipboard />
            </AuthGate>
        </Wrapper>
    )
}

export default Layout
